import {
    CBadge,
    CButton,
    CButtonGroup,
    CCol,
    CDropdown,
    CDropdownDivider,
    CDropdownItem,
    CDropdownMenu,
    CDropdownToggle,
    CFormInput,
    CInputGroup,
    CModal,
    CModalBody,
    CModalHeader,
    CModalTitle,
    CRow,
    CSpinner
} from "@coreui/bootstrap-react"
import {useState} from "react";

import CIcon from '@coreui/icons-react';
import * as icon from '@coreui/icons';

import {CWidgetStatsF} from '@coreui/react'
import {useDispatch, useSelector} from "react-redux";
import {Nav, Toast} from "react-bootstrap";
import DashboardsService from "../store/dashboards/service";
import {toast} from "react-hot-toast";

const TokenModel = () => {
    const dispatch = useDispatch();

    const tokensData = useSelector((state) => state.tokensData);
    const dashboardsData = useSelector((state) => state.dashboardsData);

    const [visible, setVisible] = useState(false)
    const [selectedItems, setSelectedItems] = useState([])
    const [search, setSearch] = useState("")


    const handelSelecetItem = (objID) => {
        const objInList = selectedItems.find((e) => {
            return e === objID
        })
        let filteredArray = []
        if (objInList !== undefined) {
            filteredArray = selectedItems.filter(item => item !== objID)
        } else {
            filteredArray = [...selectedItems, objID]
        }
        setSelectedItems(filteredArray)
    }

    const clearSelecetedItems = () => (
        setSelectedItems([])
    )

    const validationSelecetedItems = () => {
        if (selectedItems.length > 0) {
            return true
        }
        toast.error('لطفا حداقل یک توکن را انتخاب نمایید.')
        return false
    }

    const handelRemoveItems = () => {
        if (validationSelecetedItems() === true) {
            DashboardsService.makeAction(dispatch, {action: 'remove_token', items: selectedItems});
            clearSelecetedItems();
            setSearch("");
            toast.success('ایتم های انتخاب شده با موفقیت حذف گردید.')
        }

    }

    const handelMoveItems = (dashboard_key) => {
        if (validationSelecetedItems() === true) {
            DashboardsService.makeAction(dispatch, {
                action: 'move_tokens',
                dashboard: dashboard_key,
                items: selectedItems
            });
            clearSelecetedItems();
            toast.success('ایتم های انتخاب شده با موفقیت انتقال یافت.')
        }
    }

    const handelBoxColor = (item) => {
        if (selectedItems.find((e) => {
            return e === item.id
        })) {
            return {borderColor: "#ff6c79", background: "#ff6c79"}
        } else {
            return {}
        }
    }
    const handelIsUsed = (item) => {
        if (item.is_used) {
            return "success"
        } else {
            return "danger"
        }
    }


    return (
        <>
            {(tokensData.loading) ? (
                // <div className="row justify-content-center ">
                //     <CSpinner color="secondary" />
                // </div>
                <Nav.Link>توکن ها</Nav.Link>
            ) : (
                <>
                    <Nav.Link onClick={() => setVisible(!visible)}>توکن ها</Nav.Link>
                    <CModal size="xl" visible={visible} onClose={() => setVisible(false)}>
                        <CModalHeader>
                            <CModalTitle>لیست توکن ها تایید شده </CModalTitle>
                        </CModalHeader>
                        <CModalBody>
                            <CRow>
                                <CCol md={4} style={{'textAlign': 'right'}} className="mb-3 mt-3">
                                    <CButtonGroup role="group" aria-label="Button group with nested dropdown">
                                        <CButton color="danger" onClick={clearSelecetedItems}>پاکسازی</CButton>
                                        <CDropdown variant="btn-group" key={1}>
                                            <CDropdownToggle color={'primary'}>عملیات رو موارد انتخاب
                                                شده</CDropdownToggle>
                                            <CDropdownMenu>
                                                <CDropdownItem onClick={() => (handelRemoveItems())}>حذف موارد انتخاب
                                                    شده</CDropdownItem>
                                                <CDropdownDivider/>
                                                {dashboardsData?.list.map((item) => (
                                                    <CDropdownItem onClick={() => (handelMoveItems(item.key))}>انتقال به
                                                        داشبورد {item.name}</CDropdownItem>
                                                ))}
                                            </CDropdownMenu>
                                        </CDropdown>
                                    </CButtonGroup>
                                </CCol>
                                <CCol md={{span: 4, offset: 4}}>
                                    <CInputGroup className="mb-3 mt-3">
                                        <CFormInput placeholder="نام توکن مورد نظر خود را وارد نمایید ..."
                                                    aria-label="نام توکن مورد نظر خود را وارد نمایید ..."
                                                    aria-describedby="button-addon2"
                                                    onChange={(e) => (setSearch(e.target.value))}/>
                                        <CButton type="button" color="secondary" variant="outline"
                                                 id="button-addon2">جستجو</CButton>
                                    </CInputGroup>
                                </CCol>
                            </CRow>
                            <CRow>
                                {tokensData?.list.filter(item => item?.name.includes(search)).map((item) => (
                                    <CCol xs={12} sm={6} xl={3}
                                          onClick={() => (handelSelecetItem(item.id))}

                                    >
                                        <CWidgetStatsF
                                            className="mb-3"
                                            color={handelIsUsed(item)}
                                            style={handelBoxColor(item)}
                                            icon={<CIcon icon={icon.cilAppsSettings} height={36}/>}
                                            title={item.name}
                                            value={
                                                <>
                                                    {item.is_renaissance ?
                                                        <CBadge color="success" className="m-1">رینانس شده</CBadge> :
                                                        <CBadge color="danger" className="m-1">رینانس نشده</CBadge>
                                                    }
                                                    {
                                                        item?.network?.key == 'eth' ?
                                                            <CBadge color="primary" className="m-1">
                                                                {item?.network?.name}
                                                            </CBadge> :
                                                            <CBadge color="success" className="m-1">
                                                                {item?.network?.name}
                                                            </CBadge>
                                                    }

                                                    {item.txns > 0 &&
                                                        <CBadge color="info" className="m-1">تعداد تراکنشات
                                                            : {item.txns}</CBadge>}
                                                </>
                                            }/>
                                    </CCol>
                                ))}
                            </CRow>
                        </CModalBody>
                    </CModal>
                </>
            )}
        </>


    )
}

export default TokenModel;